import { render, staticRenderFns } from "./BaseInstall.vue?vue&type=template&id=2244cae5&scoped=true&"
import script from "./BaseInstall.vue?vue&type=script&lang=js&"
export * from "./BaseInstall.vue?vue&type=script&lang=js&"
import style0 from "./BaseInstall.vue?vue&type=style&index=0&id=2244cae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244cae5",
  null
  
)

export default component.exports